import { Incarico } from './incarico';
import { Model } from './model';
import { Template } from './template';
import { Tavola } from './tavola';
import { User } from './user';

export class File extends Model {
  static apiUrl: string = "files";

  nome: string;
  definitivo: boolean;

  template: Template;

  incarico: Incarico;
  dimensione?: number;
  tavole: Tavola[];

  incarico_id: number;

  revisionato_da: File;
  revisione_di: File;

  temporary_url: string;
  user: User;

  deserialize(input: any): File {
    let retV: File = new File();
    retV = super.deserialize(input) as File;

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input.incarico);
    }
    if (input?.user) {
      retV.user = new User().deserialize(input.user);
    }
    if (input?.revisionato_da) {
      retV.revisionato_da = new File().deserialize(input.revisionato_da);
    }
    if (input?.revisione_di) {
      retV.revisione_di = new File().deserialize(input.revisione_di);
    }
    if (input?.tavole) {
      retV.tavole = input.tavole.map(v => new Tavola().deserialize(v));
    }
    retV.temporary_url = input?.temporary_url;

    return retV;
  }


  get storicoRevisioni(): File[] {
    let retArray: File[] = [];

    let cursorDoc = this as File;
    while (cursorDoc = cursorDoc.revisione_di) {
      retArray.push(cursorDoc);
    }

    return retArray;
  }

  get nome_con_prefisso_incarico() {
    if (!this.incarico) {
      throw "Chiamato nome_con_prefisso_incarico senza incarico caricato in file!";
    }
    return `${this.incarico.riferimento_interno}-${this.nome}`;
  }

  static sostituisciEstensioneConPDF(str) {
    let idx = str.lastIndexOf('.');
    if (idx > 0) {
      str = str.substring(0, idx);
    }
    return str + '.pdf';
  }


  static getDefaultSortKey() {
    return 'custom_default_order';
  }


  tavoleInCuiSiTrovaOltreA(id) {
    return this.tavole.filter(v => v.id != id);
  }
  nomiTavoleInCuiSiTrovaOltreA(id) {
    return this.tavole.filter(v => v.id != id).map(v => v.humanIdentifier).join('\n');;
  }
}
